import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus, {ElMessage} from 'element-plus'
import Print from 'vue3-print-nb'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import '@/style/index.scss'
import '@/index.css'
import VueScrollTo from 'vue-scrollto'
import { createPinia } from 'pinia'
import piniaPersistedState from 'pinia-plugin-persistedstate';
import {globalMixin} from "@/utils/globalMixin";
import * as jiazhiyuan from 'jiazhiyuan'

let scrollOptions = {
    container: "body", //滚动的容器
    duration: 500, //滚动时间
    easing: "ease", //缓动类型
    offset: -50, // 滚动时应应用的偏移量。此选项接受回调函数
    force: true, // 是否应执行滚动
    cancelable: true, // 用户是否可以取消滚动
    onStart: false, // 滚动开始时的钩子函数
    onDone: false, // 滚动结束时候的钩子函数
    onCancel: false, // 用户取消滚动的钩子函数
    x: false, // 是否要在x轴上也滚动
    y: true    // 是否要在y轴上滚动
}

//需引入默认样式
document.documentElement.setAttribute('data-theme', 'light');

// 设置标题
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

window._AMapSecurityConfig = {
    securityJsCode: '5895be2baa5c7d21265b84f3800ceb2a'
}

const pinia = createPinia()
pinia.use(piniaPersistedState);
const app = createApp(App)
// ElMessage.install = (app) => {
//     app.config.globalProperties.$message = (options) => {
//         options.zIndex = 3000; // 设置自定义层级
//         return ElMessage(options);
//     };
// };
app.config.globalProperties.$jiazhiyuan = jiazhiyuan;
app.mixin(globalMixin)
app.use(Print).use(ElementPlus).use(pinia).use(router).use(VueScrollTo,scrollOptions).mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
